module.exports = __webpack_public_path__ + "static/media/review.4e7821d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/review.png
// module id = 188
// module chunks = 0